export default [
    {
        path: '/beneficiarios',
        name: 'beneficiarios',
        component: () => import('@/modules/Beneficiarios'),
        meta: {
            requiresAuth: false,
            title: 'Beneficiarios | Fundación Rebeca Lan'
        },
    }
];
